import { render, staticRenderFns } from "./dormFixMng.vue?vue&type=template&id=7ce5bd46&scoped=true"
import script from "./dormFixMng.vue?vue&type=script&lang=js"
export * from "./dormFixMng.vue?vue&type=script&lang=js"
import style0 from "./dormFixMng.vue?vue&type=style&index=0&id=7ce5bd46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce5bd46",
  null
  
)

export default component.exports